export default function EventsPage() {
    return (
        <div className="py-10">
            <h1 className="text-4xl font-black uppercase text-white">Événements</h1>
        </div>
    );
}